import {getJsContext, getRecaptchaToken, getUrlTranslation} from "../app"
import {ajaxErrorAlert, ajaxPost, toggleBetweenElements} from "./utils";

$(function () {
  const checkSubrogationDebtForm = $('#checkSubrogationDebtForm');
  const selectSubrogationDebtForm = $('#selectSubrogationDebtForm');
  const paySubrogationDebtForm = $('#paySubrogationDebtForm');

  checkSubrogationDebtForm.on('submit', (e) => {
    e.preventDefault();
    const form = $(e.target);

    toggleBetweenElements(paySubrogationDebtForm, checkSubrogationDebtForm);

    getRecaptchaToken(form)
      .then(() => {
        const data = form.serializeArray();
        checkSubrogationDebtForm.loading({
          loadingText: getJsContext('checking') + '...',
          position: "left top",
          extraClasses: "w110 p-4"
        });
        ajaxPost(getUrlTranslation('/check-subrogation-debt/'), data, form)
          .then((response) => {
            const subrogationDebts = $('#subrogationDebts');
            subrogationDebts.empty();
            const pin = checkSubrogationDebtForm.find('input[name=pin]').val();
            response['subrogations'].forEach((subrogation) => {
              subrogationDebts.append(`
              <div class="input-group mb-2">
                <div class="input-group-text">
                  <input 
                    data-act-number="${subrogation['act_number']}"
                    data-subrogation-number="${subrogation['subrogation_number']}"
                    data-total-debt="${subrogation['total_debt']}"
                    data-payed="${subrogation['payed']}"
                    data-debt="${subrogation['debt']}"
                    data-debtor="${response['debtor']}"
                    data-debtor-pin="${pin}"
                    id="subrogation_debt_${subrogation['act_number']}" name="subrogation_debt" class="form-check-input mt-0" type="radio" value="${subrogation['act_number']}" required>
                </div>
                <label for="subrogation_debt_${subrogation['act_number']}" class="form-control py-3">${subrogation['act_number']} - ${subrogation['total_debt']}/${subrogation['payed']} AZN</label>
              </div>
            `);
            });
            $('#_debtor').val(String(response['debtor']));

            const url = `/subrogation/${pin}/`;
            window.history.pushState({}, "", getUrlTranslation(url));
            toggleBetweenElements(checkSubrogationDebtForm, selectSubrogationDebtForm, 500, () => {
              $('input[name=payment_amount]').focus();
            });
          })
          .catch((errors) => {
            ajaxErrorAlert(errors, form);
          });
      })
  });

  selectSubrogationDebtForm.on('submit', (e) => {
    e.preventDefault();
    const selectedDebt = $('input[name=subrogation_debt]:checked');
    paySubrogationDebtForm.find('#act_number').val(selectedDebt.data('act-number'));
    paySubrogationDebtForm.find('#_subrogation_number').val(selectedDebt.data('subrogation-number'));
    paySubrogationDebtForm.find('#_payed').val(selectedDebt.data('payed'));
    paySubrogationDebtForm.find('#_total_debt').val(selectedDebt.data('total-debt'));
    paySubrogationDebtForm.find('#_debt').val(selectedDebt.data('debt'));
    paySubrogationDebtForm.find('#_debtor').val(selectedDebt.data('debtor'));
    paySubrogationDebtForm.find('input[name=pin]').val(selectedDebt.data('debtor-pin'));

    $('input[name=payment_amount]').val('');
    toggleBetweenElements(selectSubrogationDebtForm, paySubrogationDebtForm, 500, () => {
      $('input[name=payment_amount]').trigger('focus');
    });
  });

  paySubrogationDebtForm.on('submit', (e) => {
    e.preventDefault();
    const form = $(e.target);

    getRecaptchaToken(form)
      .then(() => {
        const actNumber = paySubrogationDebtForm.find('input[name=act_number]').val();
        const paymentAmount = paySubrogationDebtForm.find('input[name=payment_amount]').val();
        const pin = paySubrogationDebtForm.find('input[name=pin]').val();

        const data = {
          pin: pin,
          act_number: actNumber,
          payment_amount: paymentAmount,
          action: "subrogation",
          recaptcha: form.find('input[name=recaptcha]').val()
        }
        paySubrogationDebtForm.loading({
          loadingText: getJsContext('please_wait') + '...',
          position: "left top",
          extraClasses: "w110 p-4"
        });
        ajaxPost(getUrlTranslation('/get-payment-url/'), data, form)
          .then((response) => {
            paySubrogationDebtForm.loading({
              loadingText: getJsContext('redirecting') + '...',
              position: "left top",
              extraClasses: "w110 p-4"
            });
            window.location.href = String(response['redirect_url']);
          })
          .catch((errors) => {
            ajaxErrorAlert(errors, form);
          });
      })
  });

  $('#backToCheckSubrogationDebtForm').on('click', () => {
    checkSubrogationDebtForm.loading({action: "hide"})
    window.history.pushState({}, "", getUrlTranslation(`/subrogation/`));
    toggleBetweenElements(selectSubrogationDebtForm, checkSubrogationDebtForm, 500, () => {
      $('input[name=pin]').trigger('focus');
    });
  });

  $('#backToSelectSubrogationDebtForm').on('click', () => {
    $('input[name=subrogation_debt]:checked').prop('checked', false);
    toggleBetweenElements(paySubrogationDebtForm, selectSubrogationDebtForm);
  });

  const pinInput = $('input[name=pin]');
  if (pinInput.length > 0 && pinInput.val() !== "") {
    checkSubrogationDebtForm.trigger('submit');
  }
});